$(document).ready(function() {

   setTimeout(function() {


  $('.customers-slider').slick({
  dots: false,
  arrows: true,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1148/7426/files/prev.svg?v=1679383038'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1148/7426/files/next.svg?v=1679383037'>",
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false
      }
    },
    {
      breakpoint: 580,
      settings: {
      arrows: true,
      dots: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
}, 3000);
});


  $('.best-seilling-slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1148/7426/files/prev_1.svg?v=1679383381'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1148/7426/files/next_1.svg?v=1679383381'>",
  slidesToShow: 4,
  autoplay: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 560,
      settings: "unslick",
      arrows: false,
      dots: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
  ]
});
$(document).ready(function() {
   setTimeout(function() {
      $('.main-banner-slider').slick({
      dots: true,
      arrows: true,
      prevArrow:"<img class='slick-prev' src='https://cdn.shopify.com/s/files/1/1148/7426/files/prev_1.svg?v=1679383381'>",
      nextArrow:"<img class='slick-next' src='https://cdn.shopify.com/s/files/1/1148/7426/files/next_1.svg?v=1679383381'>",
      infinite: true,
      // speed: 300,
      slidesToShow: 1,
      // autoplay: true,
      // autoplaySpeed: 2000,
      adaptiveHeight: true,
      slidesToScroll: 1,
    });

    }, 2000);
});
// Product Page

$('.product-slider').slick({
      autoplay: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/63f7615d337163e022637a10/63f8b0728fa23e36f5cecbbf_prev2.svg'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/63f7615d337163e022637a10/63f8b07286dffd59b2763b48_next2.svg'>",
        asNavFor: '.product-slider-thumbnail'
    });
    $('.product-slider-thumbnail').slick({
     vertical: true,
      autoplay: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      variableWidth: false,
       responsive: [
      {
      breakpoint: 992,
      settings: {
      vertical: false,
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    });

$(document).ready(function() {
    $('label.color-field').click(function() {
        $('label.color-field').removeClass('color-active');
        $(this).addClass('color-active');
    });
});

/*
In the video, the classes are referencing "Hack 16"
This Hack is launched as "Hack 17"
Please note the change of classes from 16 to 17
*/
  // declare & initialize x at 0
  let x = 0;
  // on button click
  $('.hack17-counter-button.hack17-up').on('click', ()=>{  
    // increment & set new value 
    $('.hack17-counter-input.w-input').val( ++x );
  });
  $('.hack17-counter-button.hack17-down').on('click', ()=>{  	
    // decrement & set new value 
    if(x > 0){
      $('.hack17-counter-input.w-input').val( --x );
    }
  });
  /* This next part was added post-video recording added
  to make sure the plus and minus work with a manual entry of
  a number in the text input. If you type 5 into the input manually,
  and then press (+), it will count to 6 instead of starting to
  count at 1. Nice!!
  */
  // on input value change
  $('.hack17-counter-input.w-input').change(function(){
    // convert input value to number
    const num = Number($(this).val());
    // if it's a number
    if(num){
      // assign its value to x
      x = num;
    }
  });

 $(document).ready(function() {
   $('.product-main-section .header-product-descx-link').click(function() {
      $('.header-product-descx.mrg-top.hidden-data').slideToggle();
      if ($('.header-product-descx-link').text() == "Read more") {
        $(this).text("Read less")
      } else {
        $(this).text("Read more")
      }
    });
 });

   
